export var RcsbWindowEventManager;
(function (RcsbWindowEventManager) {
    const intersectionCallbacks = {};
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            var _a;
            (_a = intersectionCallbacks[entry.target.id]) === null || _a === void 0 ? void 0 : _a.call(intersectionCallbacks, entry.isIntersecting);
        });
    }, {
        threshold: 0
    });
    function intersectionObserve(target, callback) {
        intersectionObserver.observe(target);
        intersectionCallbacks[target.id] = callback;
    }
    RcsbWindowEventManager.intersectionObserve = intersectionObserve;
    function intersectionUnobserve(target) {
        intersectionObserver.unobserve(target);
    }
    RcsbWindowEventManager.intersectionUnobserve = intersectionUnobserve;
})(RcsbWindowEventManager || (RcsbWindowEventManager = {}));
